export default __webpack_public_path__ + "img/launcher-icon.svg";